// ─── Route Constants ─────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

// ─── Track Data ───────────────────────────────────────────────────────────────
export interface Track {
  id: number;
  title: string;
  description: string;
  file: string;
  genre: string;
  duration?: string;
}

export const TRACKS: Track[] = [
  {
    id: 1,
    title: 'How to Train Your Dragon',
    description: 'Orchestral arrangement — Konstantin Solopov',
    file: '/audio/how-to-train-your-dragon.mp3',
    genre: 'Orchestral / Cover',
  },
  {
    id: 2,
    title: 'Sad Departure',
    description: 'Original composition',
    file: '/audio/sad-departure.mp3',
    genre: 'Cinematic',
  },
  {
    id: 3,
    title: 'The Story of Samurai',
    description: 'Original composition',
    file: '/audio/story-of-samurai.mp3',
    genre: 'Epic / Eastern',
  },
  {
    id: 4,
    title: 'The Rain Maker',
    description: 'Original composition',
    file: '/audio/rain-maker.mp3',
    genre: 'Atmospheric',
  },
  {
    id: 5,
    title: 'The Mystery of Alps',
    description: 'Original composition',
    file: '/audio/mystery-of-alps.mp3',
    genre: 'Cinematic',
  },
  {
    id: 6,
    title: 'The Race Begins — Test Your Limits',
    description: 'Original composition',
    file: '/audio/race-begins.mp3',
    genre: 'Action / Intense',
  },
  {
    id: 7,
    title: 'Excitement',
    description: 'Original composition',
    file: '/audio/excitement.wav',
    genre: 'Uplifting',
  },
];

// ─── Services ─────────────────────────────────────────────────────────────────
export interface Service {
  icon: string;
  title: string;
  description: string;
  color: string;
}

export const SERVICES: Service[] = [
  {
    icon: '🎬',
    title: 'Film Scoring',
    description: 'Original orchestral and hybrid scores crafted to serve the story — from intimate dramas to sweeping epics.',
    color: 'primary',
  },
  {
    icon: '🎮',
    title: 'Game Music',
    description: 'Adaptive, loopable soundtracks that draw players deeper into your world and react to every moment.',
    color: 'accent',
  },
  {
    icon: '🔊',
    title: 'Sound Design',
    description: 'Immersive soundscapes, SFX, and audio post-production that bring your visuals to life.',
    color: 'chart-3',
  },
  {
    icon: '🎼',
    title: 'Custom Arrangements',
    description: 'Full orchestral arrangements of existing themes for trailers, pitches, or concert performance.',
    color: 'chart-4',
  },
  {
    icon: '🎻',
    title: 'Orchestration',
    description: 'Translating compositional ideas into idiomatic, playable orchestral parts — balancing colour, texture, and dynamics across the full ensemble.',
    color: 'chart-5',
  },
  {
    icon: '📄',
    title: 'Score Preparation',
    description: 'Clean, performance-ready scores and parts — properly formatted, paginated, and delivered on time for recording sessions or live performance.',
    color: 'primary',
  },
  {
    icon: '✂️',
    title: 'Music Editing',
    description: 'Precise editing to picture: syncing hits, managing tempo maps, conforming music to editorial changes, and maintaining sync throughout post.',
    color: 'accent',
  },
  {
    icon: '🎧',
    title: 'Music Supervision',
    description: 'Curating and licensing existing music, coordinating with publishers, and ensuring every track serves the creative vision and legal requirements.',
    color: 'chart-3',
  },
];

// ─── Utility ──────────────────────────────────────────────────────────────────
export function formatTime(seconds: number): string {
  if (!isFinite(seconds) || isNaN(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
